<script>
  import { getAutoMpsProjectContext } from "../../../AutoMpsProjectContext.js";
  import { useMe } from "../../../../hooks/useMe.js";
  import PSITable from "../../../../views/MPS/PSITable/PSITable.svelte";
  import AutoMpsProjectExecutionViewPageBase from "./AutoMpsProjectExecutionViewPageBase.svelte";
  import FetchAutoMpsPsiTableData from "./FetchAutoMpsPsiTableData.svelte";

  const ctx = getAutoMpsProjectContext()

  const me = useMe()

  const projectId = $ctx.projectId
  const executionId = $ctx.executionId
</script>

<AutoMpsProjectExecutionViewPageBase viewName="PSI表">
  <FetchAutoMpsPsiTableData
    projectId={projectId}
    executionId={executionId}
    let:data
  >
    <PSITable
      user={$me}
      projectId={projectId}
      executionId={executionId}
      data={data}
    />
  </FetchAutoMpsPsiTableData>
</AutoMpsProjectExecutionViewPageBase>
